"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addMatchMediaListener = addMatchMediaListener;
exports.removeMatchMediaListener = removeMatchMediaListener;
var _browser = require("./browser");
var _mediaQueryListener = require("./mediaQueryListener");
const callbackByQueryMap = new Map();
const listenerByQueryMap = new Map();

// Registers a global event listener only once per media query
function addMatchMediaListener(deviceQuery, cb) {
  var _callbackByQueryMap$g;
  // Adds the callback associated with the device query to the set
  const set = (_callbackByQueryMap$g = callbackByQueryMap.get(deviceQuery)) !== null && _callbackByQueryMap$g !== void 0 ? _callbackByQueryMap$g : new Set();
  set.add(cb);
  callbackByQueryMap.set(deviceQuery, set);

  // if we don't have a global listener for device query then we can set it up
  if (!listenerByQueryMap.has(deviceQuery)) {
    var _getBrowserGlobals;
    // creates an event handler that fires all the callbacks associated with the query
    const listenerByQuery = () => {
      for (const fn of Array.from(callbackByQueryMap.get(deviceQuery))) {
        fn();
      }
    };
    listenerByQueryMap.set(deviceQuery, listenerByQuery);
    // attach a single listener per query, and assign a single callback with will fire all callbacks associated with that query
    const mediaQuery = (_getBrowserGlobals = (0, _browser.getBrowserGlobals)()) === null || _getBrowserGlobals === void 0 ? void 0 : _getBrowserGlobals.window.matchMedia(deviceQuery);
    (0, _mediaQueryListener.addMediaQueryListener)(mediaQuery, listenerByQuery);
  }
}
function removeMatchMediaListener(deviceQuery, cb) {
  var _callbackByQueryMap$g2;
  // find key of map for device query
  const set = (_callbackByQueryMap$g2 = callbackByQueryMap.get(deviceQuery)) !== null && _callbackByQueryMap$g2 !== void 0 ? _callbackByQueryMap$g2 : new Set();
  // remove callback from the device query map
  if (set.has(cb)) {
    set.delete(cb);
  }

  // If there are no callbacks left we can remove global media query listener
  if (set.size === 0) {
    if (listenerByQueryMap.has(deviceQuery)) {
      var _getBrowserGlobals2;
      const mediaQuery = (_getBrowserGlobals2 = (0, _browser.getBrowserGlobals)()) === null || _getBrowserGlobals2 === void 0 ? void 0 : _getBrowserGlobals2.window.matchMedia(deviceQuery);
      const handler = listenerByQueryMap.get(deviceQuery);
      (0, _mediaQueryListener.removeMediaQueryListener)(mediaQuery, handler);
      listenerByQueryMap.delete(deviceQuery);
    }
  }
}